module.exports = __webpack_public_path__ + "static/media/thonburi.7d35615b.svg";